import { createClient } from "@connectrpc/connect";
import { EnlacesService } from "../../../generated/grpc/comun_enlaces_pb";
import { grpcTransportProvider } from "../grpc/GrpcTransport";
import { mapConnectError } from "../grpc/mapConnectError";

/** Resuelve un link acortado de Google Maps (`maps.app.goo.gl`/`goo.gl/maps`)
 *  del lado servidor — el navegador no puede seguir esa redirección directo
 *  por CORS. Retorna la URL final (con la coordenada visible), lista para el
 *  mismo parseo por regex que ya usa el buscador para links largos. Sin
 *  caché: cada búsqueda pega un link distinto. Se pide por gRPC-Web
 *  (`EnlacesService.ResolverGoogleMaps` — antes
 *  `GET comun/enlaces/resolver-google-maps`, ver CLAUDE.md del Server,
 *  sección migración a gRPC-Web). */
export const resolverGoogleMapsLinkAsync = async (url: string): Promise<string> => {
  const client = createClient(EnlacesService, grpcTransportProvider.get());

  try {
    const response = await client.resolverGoogleMaps({ url });
    return response.urlResuelta;
  } catch (error) {
    throw mapConnectError(error);
  }
};
